module.exports = {"210505001":"南芬街道","210505004":"思山岭街道","210505005":"下马塘街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210505.json
// module id = 630
// module chunks = 0